















































import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { ChatHelper } from '@signing-page/chat/helpers/chat.helper';
import { IComment } from '@signing-page/chat/types/comment';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { IUser } from '@signing-page/users/types/user';

@Component({
  data: () => ({
    ChatHelper,
  }),
})
export default class ChatComment extends Vue {
  @Prop() comment!: IComment;
  @Prop() comments!: IComment[];
  @Prop() recipients: IRecipient[];
  @Prop() sender!: IUser;
  @Prop() recipientId!: string;

  showMessageTimestamp = false;

  get commentIsByMe(): boolean {
    if (this.comment.userId) {
      return false;
    }
    return ChatHelper.isByMe(this.comment, this.recipientId);
  }

  get me(): IRecipient {
    return this.recipients.find((recipient: IRecipient) => recipient.id === this.recipientId);
  }

  get commentAuthor(): IRecipient | IUser {
    if (this.comment.userId) {
      return this.sender;
    }
    return this.recipients.find(recipient => recipient.id === this.comment.recipientId);
  }

  get name(): string {
    return this.commentIsByMe ? '' : ChatHelper.getFullName(this.commentAuthor);
  }

  get thumbUrl(): string {
    return this.commentIsByMe ? '' : ChatHelper.getThumbUrl(this.commentAuthor);
  }

  get previousComment(): IComment {
    return ChatHelper.getPreviousComment(this.comment, this.comments);
  }

  get nextComment(): IComment {
    return ChatHelper.getNextComment(this.comment, this.comments);
  }

  get lastComment(): IComment {
    return ChatHelper.getLastComment(this.comments);
  }

  get firstCommentInBlock(): boolean {
    return this.isFirstCommentInMonologue || this.showTimestamp;
  }

  get isFirstCommentInMonologue(): boolean {
    if (!this.previousComment) {
      return true;
    }
    if (ChatHelper.isByMe(this.previousComment, this.recipientId)) {
      return !this.commentIsByMe;
    }
    return this.previousComment.recipientId !== this.comment.recipientId;
  }

  get showTimestamp(): boolean {
    if (!this.previousComment) {
      return true;
    }
    const diff = moment(this.comment.createdAt).diff(this.previousComment.createdAt);

    return moment.duration(diff).asHours() > 1;
  }

  get isLastCommentInMonologue(): boolean {
    if (this.comment.id === this.lastComment.id) {
      return true;
    }
    const diff = moment(this.nextComment.createdAt).diff(this.comment.createdAt);

    if (ChatHelper.isByMe(this.nextComment, this.recipientId)) {
      return (
        !ChatHelper.isByMe(this.comment, this.recipientId) || moment.duration(diff).asHours() > 1
      );
    }

    return (
      this.nextComment.recipientId !== this.comment.recipientId ||
      moment.duration(diff).asHours() > 1
    );
  }

  get date(): string {
    return ChatHelper.getDate(this.timestamp, this.at);
  }

  get time(): string {
    return ChatHelper.getTime(this.timestamp, this.at);
  }

  get at(): string {
    return this.$t('at').toString();
  }

  get timestamp(): string {
    return moment(this.comment.createdAt).calendar(null, {
      sameDay: `[${this.$t('today-at').toString()}] LT`,
      lastDay: `[${this.$t('yesterday-at').toString()}] LT`,
      lastWeek: `LL [${this.at}] LT`,
      sameElse: `LL [${this.at}] LT`,
    });
  }
  clickOutside() {
    this.toggleMessageTimestamp(false);
  }

  toggleMessageTimestamp(show: boolean) {
    this.showMessageTimestamp = show;
  }
}
